export const getTable = state => state.updateTable.uuid;

export default {
	getTable,
};
